import { Box } from '@mui/material';
import PropTypes from 'prop-types';

export default function TabPanel(props) {
	const { children, value, index, name, ...other } = props;

	return (
		<div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${name}`} aria-labelledby={`simple-tab-${name}`} {...other}>
			{value === index && <Box className={props.boxClassName}>{children}</Box>}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
};
